export default {
  ACTIVE_SUCCESS: '#59D499',
  text_on_secondary: '#FFFEFE',
  text_primary: '#374050',
  text_secondary: '#959FAF',
  text_on_primary: '#FFFEFE',
  primary_web: '#20293C',
  primary_web_color1: '#3a416f',
  primary_web_color2: '#141727',
  primary: '#20293C',
  secondary: '#7DA3AC',
  tertiary: '#EF7E6C',
  background_dividers: '#D9D9D9',
  background_secondary: '#FFFFFF',
  background_soft: '#ebebef',
  background_blurry: '#e5e5e680',
  background_modal: '#F5F5F5',
  BG_MENU: '#F9F9F9',
  BG_Header_Card: '#20293C',
  line_separator: '#EFF3F9',
  LINES_GRAPHS: '#EFF3F9',
  icon_secondary: '#959FAF',
  icon_on_secondary: '#FFFEFE',
  notification_failed: '#FF5252',
  ARTICLE_PICTURE_OFF: '#DFE2E6',
  WHITE: '#FFFFFF',
  BLUE: '#A4C7FC',
  GREEN: '#7ED9BDCC',
  PURPLE: '#9295EACC',
  PINK: '#F19BC0CC',
  ORANGE: '#F6C283CC',
  ORANGELOGIN: '#20293C',
  YELLOW: '#F9D674CC',
  GREY: '#DDDBE0',
  GREY2: '#EAEAEA',
  GREY3: '#F1F1F1',
  text_dark: '#4F4F4F',
  divider: '#EBEFF2',
  greyOutline: '#bbb',
};
